module.exports = __webpack_public_path__ + "static/media/chill-spins-120x120-transparent.15c9f8cf.png";